<section class="section--pdf-back-page pdf-page-wrapper">
  <div class="back-page-address">
    <div class="back-page-address__name" [innerText]="user!.data.FULL_NAME"></div>
    <div class="back-page-address__content">
      @for (line of address; track trackByFn($index, line)) {
        <span class="d-block" [innerText]="line"></span>
      }
    </div>
  </div>
</section>

